import { DEFAULT_PAGE_SIZE } from '~settings/constants';

export function usePageSize(perPage?: number) {
  return perPage ?? DEFAULT_PAGE_SIZE;
}
